@file:OptIn(InternalResourceApi::class)

package kinoshazam.resources.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/kinoshazam.resources.generated.resources/"

public val Res.string.decide_seeds_hint: StringResource by lazy {
      StringResource("string:decide_seeds_hint", "decide_seeds_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6135, 113),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8690, 149),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6135, 113),
      ))
    }

public val Res.string.decide_seeds_more: StringResource by lazy {
      StringResource("string:decide_seeds_more", "decide_seeds_more", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6249, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8840, 53),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6249, 41),
      ))
    }

public val Res.string.decide_seeds_title: StringResource by lazy {
      StringResource("string:decide_seeds_title", "decide_seeds_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6291, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8894, 98),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6291, 54),
      ))
    }

public val Res.string.decide_skip: StringResource by lazy {
      StringResource("string:decide_skip", "decide_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6346, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8993, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6346, 27),
      ))
    }

public val Res.string.decide_tag_animation: StringResource by lazy {
      StringResource("string:decide_tag_animation", "decide_tag_animation", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6374, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9041, 60),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6374, 40),
      ))
    }

public val Res.string.decide_tag_horror: StringResource by lazy {
      StringResource("string:decide_tag_horror", "decide_tag_horror", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6415, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9102, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6415, 33),
      ))
    }

public val Res.string.decide_tag_romance: StringResource by lazy {
      StringResource("string:decide_tag_romance", "decide_tag_romance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6449, 38),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9144, 50),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6449, 38),
      ))
    }

public val Res.string.decide_tag_slow: StringResource by lazy {
      StringResource("string:decide_tag_slow", "decide_tag_slow", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6488, 31),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9195, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6488, 31),
      ))
    }

public val Res.string.decide_tag_violence: StringResource by lazy {
      StringResource("string:decide_tag_violence", "decide_tag_violence", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6520, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9243, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6520, 35),
      ))
    }

public val Res.string.decide_title: StringResource by lazy {
      StringResource("string:decide_title", "decide_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6556, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9291, 56),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6556, 44),
      ))
    }

public val Res.string.decide_vote_pass: StringResource by lazy {
      StringResource("string:decide_vote_pass", "decide_vote_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6601, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9348, 52),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6601, 40),
      ))
    }

public val Res.string.decide_vote_seen: StringResource by lazy {
      StringResource("string:decide_vote_seen", "decide_vote_seen", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6642, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9401, 52),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6642, 40),
      ))
    }

public val Res.string.decide_vote_skip: StringResource by lazy {
      StringResource("string:decide_vote_skip", "decide_vote_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6683, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9454, 40),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6683, 36),
      ))
    }

public val Res.string.decide_vote_watch: StringResource by lazy {
      StringResource("string:decide_vote_watch", "decide_vote_watch", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6720, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9495, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6720, 37),
      ))
    }

public val Res.string.decide_watch: StringResource by lazy {
      StringResource("string:decide_watch", "decide_watch", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6798, 28),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9585, 44),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6798, 28),
      ))
    }

public val Res.string.decide_watch_in: StringResource by lazy {
      StringResource("string:decide_watch_in", "decide_watch_in", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6758, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9541, 43),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6758, 39),
      ))
    }

public val Res.string.decide_with_subtitles: StringResource by lazy {
      StringResource("string:decide_with_subtitles", "decide_with_subtitles", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6827, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9630, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6827, 49),
      ))
    }

public val Res.string.delete_from_history: StringResource by lazy {
      StringResource("string:delete_from_history", "delete_from_history", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6877, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9692, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6877, 35),
      ))
    }

public val Res.string.details_cast: StringResource by lazy {
      StringResource("string:details_cast", "details_cast", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6913, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1990, 40),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9740, 40),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6913, 28),
      ))
    }

public val Res.string.details_episodes_title: StringResource by lazy {
      StringResource("string:details_episodes_title", "details_episodes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6942, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2031, 74),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9781, 74),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6942, 58),
      ))
    }

public val Res.string.details_less: StringResource by lazy {
      StringResource("string:details_less", "details_less", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7001, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2106, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9856, 36),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7001, 28),
      ))
    }

public val Res.string.details_more: StringResource by lazy {
      StringResource("string:details_more", "details_more", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7030, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2143, 28),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9893, 28),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7030, 28),
      ))
    }

public val Res.string.details_watch_also: StringResource by lazy {
      StringResource("string:details_watch_also", "details_watch_also", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7059, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2172, 66),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9922, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7059, 38),
      ))
    }

public val Res.string.detective: StringResource by lazy {
      StringResource("string:detective", "detective", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7098, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2239, 29),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 9989, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7098, 29),
      ))
    }

public val Res.string.drama: StringResource by lazy {
      StringResource("string:drama", "drama", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7128, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2269, 21),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10031, 29),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7128, 21),
      ))
    }

public val Res.string.episode: StringResource by lazy {
      StringResource("string:episode", "episode", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7208, 31),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2349, 31),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10143, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7208, 31),
      ))
    }

public val Res.string.episode_error: StringResource by lazy {
      StringResource("string:episode_error", "episode_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7150, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2291, 57),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10061, 81),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7150, 57),
      ))
    }

public val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7240, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2381, 73),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10179, 73),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7240, 53),
      ))
    }

public val Res.string.family: StringResource by lazy {
      StringResource("string:family", "family", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7294, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2455, 22),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10253, 38),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7294, 22),
      ))
    }

public val Res.string.fantastic: StringResource by lazy {
      StringResource("string:fantastic", "fantastic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7317, 25),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2478, 25),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10292, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7317, 25),
      ))
    }

public val Res.string.favorite: StringResource by lazy {
      StringResource("string:favorite", "favorite", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7478, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2715, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10533, 44),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7478, 28),
      ))
    }

public val Res.string.favorite_empty: StringResource by lazy {
      StringResource("string:favorite_empty", "favorite_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7343, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2504, 82),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10338, 82),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7343, 66),
      ))
    }

public val Res.string.favorite_sync: StringResource by lazy {
      StringResource("string:favorite_sync", "favorite_sync", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7410, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2587, 85),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10421, 69),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7410, 37),
      ))
    }

public val Res.string.favorites: StringResource by lazy {
      StringResource("string:favorites", "favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7448, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2673, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10491, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7448, 29),
      ))
    }

public val Res.string.fentesy: StringResource by lazy {
      StringResource("string:fentesy", "fentesy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7507, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2760, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10578, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7507, 27),
      ))
    }

public val Res.string.film_label: StringResource by lazy {
      StringResource("string:film_label", "film_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7535, 26),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10614, 34),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7535, 26),
      ))
    }

public val Res.string.films: StringResource by lazy {
      StringResource("string:films", "films", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7671, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2897, 29),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10798, 29),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7671, 21),
      ))
    }

public val Res.string.films_soon: StringResource by lazy {
      StringResource("string:films_soon", "films_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7562, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2788, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10649, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7562, 54),
      ))
    }

public val Res.string.films_watched: StringResource by lazy {
      StringResource("string:films_watched", "films_watched", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7617, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2843, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10716, 81),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7617, 53),
      ))
    }

public val Res.string.forgot_password_button_change: StringResource by lazy {
      StringResource("string:forgot_password_button_change", "forgot_password_button_change", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7693, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 2927, 77),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10828, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7693, 45),
      ))
    }

public val Res.string.forgot_password_button_send: StringResource by lazy {
      StringResource("string:forgot_password_button_send", "forgot_password_button_send", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7739, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3005, 59),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10906, 59),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7739, 43),
      ))
    }

public val Res.string.forgot_password_code_hint: StringResource by lazy {
      StringResource("string:forgot_password_code_hint", "forgot_password_code_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7783, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3065, 61),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 10966, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7783, 49),
      ))
    }

public val Res.string.forgot_password_code_title: StringResource by lazy {
      StringResource("string:forgot_password_code_title", "forgot_password_code_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7833, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3127, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11028, 42),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7833, 42),
      ))
    }

public val Res.string.forgot_password_resend: StringResource by lazy {
      StringResource("string:forgot_password_resend", "forgot_password_resend", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7876, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3170, 94),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11071, 94),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7876, 62),
      ))
    }

public val Res.string.forgot_password_send: StringResource by lazy {
      StringResource("string:forgot_password_send", "forgot_password_send", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7939, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3265, 64),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11166, 64),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7939, 40),
      ))
    }

public val Res.string.forgot_password_title: StringResource by lazy {
      StringResource("string:forgot_password_title", "forgot_password_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 7980, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3330, 85),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11231, 85),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 7980, 53),
      ))
    }

public val Res.string.genres: StringResource by lazy {
      StringResource("string:genres", "genres", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8034, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3416, 30),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11317, 30),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8034, 22),
      ))
    }

public val Res.string.history: StringResource by lazy {
      StringResource("string:history", "history", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8446, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3447, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11893, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8446, 27),
      ))
    }

public val Res.string.history_all: StringResource by lazy {
      StringResource("string:history_all", "history_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8057, 23),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11348, 27),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8057, 23),
      ))
    }

public val Res.string.history_earlier: StringResource by lazy {
      StringResource("string:history_earlier", "history_earlier", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8081, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11376, 39),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8081, 35),
      ))
    }

public val Res.string.history_empty: StringResource by lazy {
      StringResource("string:history_empty", "history_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8117, 117),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11416, 181),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8117, 117),
      ))
    }

public val Res.string.history_movies: StringResource by lazy {
      StringResource("string:history_movies", "history_movies", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8235, 30),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11598, 38),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8235, 30),
      ))
    }

public val Res.string.history_series: StringResource by lazy {
      StringResource("string:history_series", "history_series", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8266, 30),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11637, 42),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8266, 30),
      ))
    }

public val Res.string.history_this_week: StringResource by lazy {
      StringResource("string:history_this_week", "history_this_week", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8297, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11680, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8297, 37),
      ))
    }

public val Res.string.history_today: StringResource by lazy {
      StringResource("string:history_today", "history_today", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8335, 29),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11742, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8335, 29),
      ))
    }

public val Res.string.history_unfinished: StringResource by lazy {
      StringResource("string:history_unfinished", "history_unfinished", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8365, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11784, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8365, 42),
      ))
    }

public val Res.string.history_yesterday: StringResource by lazy {
      StringResource("string:history_yesterday", "history_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8408, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11851, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8408, 37),
      ))
    }

public val Res.string.identify_empty: StringResource by lazy {
      StringResource("string:identify_empty", "identify_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8474, 86),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3475, 110),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 11929, 122),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8474, 86),
      ))
    }

public val Res.string.identify_found: StringResource by lazy {
      StringResource("string:identify_found", "identify_found", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8561, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3586, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12052, 78),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8561, 66),
      ))
    }

public val Res.string.identify_hint: StringResource by lazy {
      StringResource("string:identify_hint", "identify_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8628, 93),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3657, 97),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12131, 117),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8628, 93),
      ))
    }

public val Res.string.identify_wand: StringResource by lazy {
      StringResource("string:identify_wand", "identify_wand", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8722, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3755, 45),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12249, 57),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8722, 41),
      ))
    }

public val Res.string.imdb: StringResource by lazy {
      StringResource("string:imdb", "imdb", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8764, 20),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3801, 20),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12307, 20),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8764, 20),
      ))
    }

public val Res.string.kinopoisk: StringResource by lazy {
      StringResource("string:kinopoisk", "kinopoisk", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8785, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3822, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12328, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8785, 29),
      ))
    }

public val Res.string.kinoshka: StringResource by lazy {
      StringResource("string:kinoshka", "kinoshka", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8815, 20),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3864, 20),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12370, 20),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8815, 20),
      ))
    }

public val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8836, 31),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3885, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12391, 43),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8836, 31),
      ))
    }

public val Res.string.login_button_title: StringResource by lazy {
      StringResource("string:login_button_title", "login_button_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8868, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 3929, 98),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12435, 98),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8868, 46),
      ))
    }

public val Res.string.login_email_verification_error_message: StringResource by lazy {
      StringResource("string:login_email_verification_error_message", "login_email_verification_error_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8915, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4028, 114),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12534, 114),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8915, 82),
      ))
    }

public val Res.string.login_error: StringResource by lazy {
      StringResource("string:login_error", "login_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9054, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4219, 75),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12725, 75),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9054, 39),
      ))
    }

public val Res.string.login_error_message: StringResource by lazy {
      StringResource("string:login_error_message", "login_error_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 8998, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4143, 75),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12649, 75),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 8998, 55),
      ))
    }

public val Res.string.login_hint: StringResource by lazy {
      StringResource("string:login_hint", "login_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9094, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4295, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12801, 54),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9094, 34),
      ))
    }

public val Res.string.login_label: StringResource by lazy {
      StringResource("string:login_label", "login_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9129, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4350, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12856, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9129, 27),
      ))
    }

public val Res.string.login_title: StringResource by lazy {
      StringResource("string:login_title", "login_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9157, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4386, 51),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12892, 51),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9157, 39),
      ))
    }

public val Res.string.login_unknown_error_message: StringResource by lazy {
      StringResource("string:login_unknown_error_message", "login_unknown_error_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9197, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4438, 83),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 12944, 83),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9197, 63),
      ))
    }

public val Res.string.melodrama: StringResource by lazy {
      StringResource("string:melodrama", "melodrama", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9261, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4522, 29),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13028, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9261, 29),
      ))
    }

public val Res.string.new_films: StringResource by lazy {
      StringResource("string:new_films", "new_films", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9291, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4552, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13070, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9291, 29),
      ))
    }

public val Res.string.new_password_hint: StringResource by lazy {
      StringResource("string:new_password_hint", "new_password_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9321, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4602, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13120, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9321, 49),
      ))
    }

public val Res.string.new_password_label: StringResource by lazy {
      StringResource("string:new_password_label", "new_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9371, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4652, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13198, 58),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9371, 42),
      ))
    }

public val Res.string.new_tv_show: StringResource by lazy {
      StringResource("string:new_tv_show", "new_tv_show", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9414, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4695, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13257, 55),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9414, 35),
      ))
    }

public val Res.string.next_episode: StringResource by lazy {
      StringResource("string:next_episode", "next_episode", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9450, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13313, 60),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9450, 36),
      ))
    }

public val Res.string.password_error: StringResource by lazy {
      StringResource("string:password_error", "password_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9487, 134),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4751, 234),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13374, 234),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9487, 134),
      ))
    }

public val Res.string.password_hint: StringResource by lazy {
      StringResource("string:password_hint", "password_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9622, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 4986, 57),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13609, 57),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9622, 41),
      ))
    }

public val Res.string.password_label: StringResource by lazy {
      StringResource("string:password_label", "password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9664, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5044, 38),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13667, 38),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9664, 34),
      ))
    }

public val Res.string.person_filmography: StringResource by lazy {
      StringResource("string:person_filmography", "person_filmography", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9699, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5083, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13706, 58),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9699, 42),
      ))
    }

public val Res.string.popular_cartoon: StringResource by lazy {
      StringResource("string:popular_cartoon", "popular_cartoon", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9791, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5175, 83),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13850, 83),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9791, 47),
      ))
    }

public val Res.string.popular_cartoons: StringResource by lazy {
      StringResource("string:popular_cartoons", "popular_cartoons", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9742, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5126, 48),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13765, 84),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9742, 48),
      ))
    }

public val Res.string.popular_tv_cartoons: StringResource by lazy {
      StringResource("string:popular_tv_cartoons", "popular_tv_cartoons", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9839, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5259, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 13934, 87),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9839, 55),
      ))
    }

public val Res.string.profile_empty_name: StringResource by lazy {
      StringResource("string:profile_empty_name", "profile_empty_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9895, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5315, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14022, 62),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9895, 38),
      ))
    }

public val Res.string.profile_language: StringResource by lazy {
      StringResource("string:profile_language", "profile_language", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9934, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5378, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14085, 36),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9934, 36),
      ))
    }

public val Res.string.profile_login_button: StringResource by lazy {
      StringResource("string:profile_login_button", "profile_login_button", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 9971, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5415, 100),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14122, 100),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 9971, 48),
      ))
    }

public val Res.string.profile_logout: StringResource by lazy {
      StringResource("string:profile_logout", "profile_logout", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10020, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5516, 38),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14223, 38),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10020, 34),
      ))
    }

public val Res.string.profile_otp_hint: StringResource by lazy {
      StringResource("string:profile_otp_hint", "profile_otp_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10055, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5555, 88),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14262, 88),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10055, 60),
      ))
    }

public val Res.string.profile_otp_password_message: StringResource by lazy {
      StringResource("string:profile_otp_password_message", "profile_otp_password_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10116, 212),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5644, 212),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14351, 316),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10116, 212),
      ))
    }

public val Res.string.profile_otp_resend: StringResource by lazy {
      StringResource("string:profile_otp_resend", "profile_otp_resend", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10394, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5954, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14765, 62),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10394, 42),
      ))
    }

public val Res.string.profile_otp_resend_after: StringResource by lazy {
      StringResource("string:profile_otp_resend_after", "profile_otp_resend_after", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10329, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 5857, 96),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14668, 96),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10329, 64),
      ))
    }

public val Res.string.profile_otp_title: StringResource by lazy {
      StringResource("string:profile_otp_title", "profile_otp_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10437, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6025, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14828, 53),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10437, 41),
      ))
    }

public val Res.string.profile_otp_verification_message: StringResource by lazy {
      StringResource("string:profile_otp_verification_message", "profile_otp_verification_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10479, 212),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6079, 212),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 14882, 316),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10479, 212),
      ))
    }

public val Res.string.profile_subscribe: StringResource by lazy {
      StringResource("string:profile_subscribe", "profile_subscribe", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10692, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6292, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15199, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10692, 33),
      ))
    }

public val Res.string.profile_subscription: StringResource by lazy {
      StringResource("string:profile_subscription", "profile_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10726, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6342, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15249, 52),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10726, 44),
      ))
    }

public val Res.string.profile_theme: StringResource by lazy {
      StringResource("string:profile_theme", "profile_theme", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10901, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6561, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15468, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10901, 29),
      ))
    }

public val Res.string.profile_theme_auto: StringResource by lazy {
      StringResource("string:profile_theme_auto", "profile_theme_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10771, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6395, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15302, 54),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10771, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("decide_seeds_hint", Res.string.decide_seeds_hint)
  map.put("decide_seeds_more", Res.string.decide_seeds_more)
  map.put("decide_seeds_title", Res.string.decide_seeds_title)
  map.put("decide_skip", Res.string.decide_skip)
  map.put("decide_tag_animation", Res.string.decide_tag_animation)
  map.put("decide_tag_horror", Res.string.decide_tag_horror)
  map.put("decide_tag_romance", Res.string.decide_tag_romance)
  map.put("decide_tag_slow", Res.string.decide_tag_slow)
  map.put("decide_tag_violence", Res.string.decide_tag_violence)
  map.put("decide_title", Res.string.decide_title)
  map.put("decide_vote_pass", Res.string.decide_vote_pass)
  map.put("decide_vote_seen", Res.string.decide_vote_seen)
  map.put("decide_vote_skip", Res.string.decide_vote_skip)
  map.put("decide_vote_watch", Res.string.decide_vote_watch)
  map.put("decide_watch", Res.string.decide_watch)
  map.put("decide_watch_in", Res.string.decide_watch_in)
  map.put("decide_with_subtitles", Res.string.decide_with_subtitles)
  map.put("delete_from_history", Res.string.delete_from_history)
  map.put("details_cast", Res.string.details_cast)
  map.put("details_episodes_title", Res.string.details_episodes_title)
  map.put("details_less", Res.string.details_less)
  map.put("details_more", Res.string.details_more)
  map.put("details_watch_also", Res.string.details_watch_also)
  map.put("detective", Res.string.detective)
  map.put("drama", Res.string.drama)
  map.put("episode", Res.string.episode)
  map.put("episode_error", Res.string.episode_error)
  map.put("error", Res.string.error)
  map.put("family", Res.string.family)
  map.put("fantastic", Res.string.fantastic)
  map.put("favorite", Res.string.favorite)
  map.put("favorite_empty", Res.string.favorite_empty)
  map.put("favorite_sync", Res.string.favorite_sync)
  map.put("favorites", Res.string.favorites)
  map.put("fentesy", Res.string.fentesy)
  map.put("film_label", Res.string.film_label)
  map.put("films", Res.string.films)
  map.put("films_soon", Res.string.films_soon)
  map.put("films_watched", Res.string.films_watched)
  map.put("forgot_password_button_change", Res.string.forgot_password_button_change)
  map.put("forgot_password_button_send", Res.string.forgot_password_button_send)
  map.put("forgot_password_code_hint", Res.string.forgot_password_code_hint)
  map.put("forgot_password_code_title", Res.string.forgot_password_code_title)
  map.put("forgot_password_resend", Res.string.forgot_password_resend)
  map.put("forgot_password_send", Res.string.forgot_password_send)
  map.put("forgot_password_title", Res.string.forgot_password_title)
  map.put("genres", Res.string.genres)
  map.put("history", Res.string.history)
  map.put("history_all", Res.string.history_all)
  map.put("history_earlier", Res.string.history_earlier)
  map.put("history_empty", Res.string.history_empty)
  map.put("history_movies", Res.string.history_movies)
  map.put("history_series", Res.string.history_series)
  map.put("history_this_week", Res.string.history_this_week)
  map.put("history_today", Res.string.history_today)
  map.put("history_unfinished", Res.string.history_unfinished)
  map.put("history_yesterday", Res.string.history_yesterday)
  map.put("identify_empty", Res.string.identify_empty)
  map.put("identify_found", Res.string.identify_found)
  map.put("identify_hint", Res.string.identify_hint)
  map.put("identify_wand", Res.string.identify_wand)
  map.put("imdb", Res.string.imdb)
  map.put("kinopoisk", Res.string.kinopoisk)
  map.put("kinoshka", Res.string.kinoshka)
  map.put("loading", Res.string.loading)
  map.put("login_button_title", Res.string.login_button_title)
  map.put("login_email_verification_error_message", Res.string.login_email_verification_error_message)
  map.put("login_error", Res.string.login_error)
  map.put("login_error_message", Res.string.login_error_message)
  map.put("login_hint", Res.string.login_hint)
  map.put("login_label", Res.string.login_label)
  map.put("login_title", Res.string.login_title)
  map.put("login_unknown_error_message", Res.string.login_unknown_error_message)
  map.put("melodrama", Res.string.melodrama)
  map.put("new_films", Res.string.new_films)
  map.put("new_password_hint", Res.string.new_password_hint)
  map.put("new_password_label", Res.string.new_password_label)
  map.put("new_tv_show", Res.string.new_tv_show)
  map.put("next_episode", Res.string.next_episode)
  map.put("password_error", Res.string.password_error)
  map.put("password_hint", Res.string.password_hint)
  map.put("password_label", Res.string.password_label)
  map.put("person_filmography", Res.string.person_filmography)
  map.put("popular_cartoon", Res.string.popular_cartoon)
  map.put("popular_cartoons", Res.string.popular_cartoons)
  map.put("popular_tv_cartoons", Res.string.popular_tv_cartoons)
  map.put("profile_empty_name", Res.string.profile_empty_name)
  map.put("profile_language", Res.string.profile_language)
  map.put("profile_login_button", Res.string.profile_login_button)
  map.put("profile_logout", Res.string.profile_logout)
  map.put("profile_otp_hint", Res.string.profile_otp_hint)
  map.put("profile_otp_password_message", Res.string.profile_otp_password_message)
  map.put("profile_otp_resend", Res.string.profile_otp_resend)
  map.put("profile_otp_resend_after", Res.string.profile_otp_resend_after)
  map.put("profile_otp_title", Res.string.profile_otp_title)
  map.put("profile_otp_verification_message", Res.string.profile_otp_verification_message)
  map.put("profile_subscribe", Res.string.profile_subscribe)
  map.put("profile_subscription", Res.string.profile_subscription)
  map.put("profile_theme", Res.string.profile_theme)
  map.put("profile_theme_auto", Res.string.profile_theme_auto)
}
